import { uiRows } from './types-def.js';
/** `web/ledger` (1.M-2): secrets, play and discovery. */
export const LEDGER_INTERACTIONS = uiRows([
    {
        id: 'ledger.secret.reveal',
        module: 'web/ledger',
        behavior: 'Revealing a secret records a knowledge event, and its state changes everywhere it shows',
        owner: '1.M-2',
        since: 'exit-1b',
    },
]);
//# sourceMappingURL=ledger.js.map